import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'mr',
  months: [
    'जानेवारी',
    'फेब्रुवारी',
    'मार्च',
    'एप्रिल',
    'मे',
    'जून',
    'जुलै',
    'ऑगस्ट',
    'सप्टेंबर',
    'ऑक्टोबर',
    'नोव्हेंबर',
    'डिसेंबर',
  ],
  monthsShort: ['जाने', 'फेब्रु', 'मार्च', 'एप्रि', 'मे', 'जून', 'जुलै', 'ऑग', 'सप्टें', 'ऑक्टो', 'नोव्हें', 'डिसें'],
  weekdays: ['रविवार', 'सोमवार', 'मंगळवार', 'बुधवार', 'गुरुवार', 'शुक्रवार', 'शनिवार'],
  weekdaysMin: ['र', 'सो', 'मं', 'बु', 'गु', 'शु', 'श'],
  weekdaysShort: ['रवि', 'सोम', 'मंगळ', 'बुध', 'गुरू', 'शुक्र', 'शनि'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'H:mm ([[GMT]]Z)',
    'LLL+to': 'D MMMM, YYYY, H:mm ([[GMT]]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s वर्षापूर्वी', other: '%s वर्षांपूर्वी' },
    M: { one: '%s महिन्यापूर्वी', other: '%s महिन्यांपूर्वी' },
    w: { one: '%s आठवड्यापूर्वी', other: '%s आठवड्यांपूर्वी' },
    d: { one: '%s दिवसापूर्वी', other: '%s दिवसांपूर्वी' },
    h: { one: '%s तासापूर्वी', other: '%s तासांपूर्वी' },
    m: { one: '%s मिनि. पूर्वी', other: '%s मिनि. पूर्वी' },
    s: { one: '%s से. पूर्वी', other: '%s से. पूर्वी' },
  },
  future: {
    y: { one: '%s वर्षामध्ये', other: '%s वर्षांमध्ये' },
    M: { one: '%s महिन्यामध्ये', other: '%s महिन्यामध्ये' },
    w: { one: 'येत्या %s आठवड्यामध्ये', other: 'येत्या %s आठवड्यांमध्ये' },
    d: { one: '%s दिवसामध्ये', other: 'येत्या %s दिवसांमध्ये' },
    h: { one: '%s तासामध्ये', other: '%s तासांमध्ये' },
    m: { one: '%s मिनि. मध्ये', other: '%s मिनि. मध्ये' },
    s: { one: '%s से. मध्ये', other: '%s से. मध्ये' },
  },
  abbr: {
    y: { one: '%sवर्ष', other: '%sवर्षे' },
    M: { one: '%sम', other: '%sम' },
    w: { one: '%sआ', other: '%sआ' },
    d: { one: '%sदि', other: '%sदि' },
    h: { one: '%sता', other: '%sता' },
    m: { one: '%sमि', other: '%sमि' },
    s: { one: '%sसे', other: '%sसे' },
  },
  justNow: 'आत्ताच',
  yesterday: 'काल',
  today: 'आज',
  tomorrow: 'उद्या',
  weekStart: 0,
};
const localeName: LocaleName = 'mr';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
